import { PROMOTION_TYPE } from '@/views/config/coupon/helper/constant';
import store from '@/store';

/**
 * Get promotion discount info by promotion type
 * @param {string} promotionType - Promotion type
 * @returns {PromotionDiscountInfoBean} Discount info
 */
const getPromotionDiscountInfoByType = (promotionType) => {
  return store.getters.promotionDiscountInfoMap?.[promotionType] || {};
};

/**
 * Get promotion info by promotion type
 * @param {string} promotionType - Promotion type
 * @returns {PromotionInfoBean} Promotion info
 */
const getPromotionInfoByType = (promotionType) => {
  return store.getters.promotionInfo?.[promotionType] || {};
};

/**
 * Get soft bundle promotion information including basic info and discount info
 * @returns {Object} Soft bundle promotion information
 */
export const getSoftBundlePromotionInfo = () => {
  return {
    basicInfo: getPromotionInfoByType(PROMOTION_TYPE.softBundle),
    discountInfo: getPromotionDiscountInfoByType(PROMOTION_TYPE.softBundle),
  };
};
